module.exports = __webpack_public_path__ + "static/media/background-card.4336f3d7.svg";